<template>
  <div
    class="modal fade"
    :ref="`modal-product-detail`"
    data-keyboard="false"
    data-backdrop="static"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            {{
              $t(
                productData.id === 0
                  ? "product.addNewProduct"
                  : "product.productDetail"
              )
            }}
          </h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group required">
                <label class="control-label required" for="">{{
                  $t("product.productList.productCode")
                }}</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="productData.productCode"
                />
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group required">
                <label class="control-label required" for="">{{
                  $t("product.productList.productName")
                }}</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="productData.productName"
                />
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group required">
                <label class="control-label required" for="">{{
                  $t("product.productGroup")
                }}</label>
                <v-select
                  class="clear"
                  :options="productGroupList"
                  v-model="productData.productGroup"
                  :reduce="data => data.id"
                  :getOptionLabel="option => $t(option.productGroupName)"
                  :placeholder="$t('product.productGroup')"
                >
                  <template v-slot:option="option">
                    {{ $t(option.productGroupName) }}
                  </template>
                </v-select>
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group required">
                <label class="control-label required" for="">{{
                  $t("product.productUnit")
                }}</label>
                <v-select
                  class="clear"
                  :options="productUnitList"
                  v-model="productData.productUnit"
                  :reduce="data => data.id"
                  :getOptionLabel="option => $t(option.productUnit)"
                  :placeholder="$t('product.productUnit')"
                >
                  <template v-slot:option="option">
                    {{ $t(option.productUnit) }}
                  </template>
                </v-select>
              </div>
            </div>

            <div class="col-md-12">
              <div class="form-group required">
                <label class="control-label required" for="">{{
                  $t("product.productList.productPrice")
                }}</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="productData.productPrice"
                />
              </div>
            </div>
            <div class="col-md-12">
              <div class="form-group">
                <label for="">{{ $t("apartmentGroup.description") }}</label>
                <textarea
                  class="form-control"
                  name=""
                  id=""
                  cols="30"
                  rows="4"
                  v-model="productData.productDescription"
                ></textarea>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            style="background-color: #f29911;border-color: #f29911;color:#fff"
            type="button"
            class="btn btn-default pull-left"
            data-dismiss="modal"
          >
            {{ $t("common.back") }}
          </button>
          <button type="button" class="btn btn-primary" @click="onSave">
            {{ $t("common.save") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import utils from "@/lib/utils";
// import Enum from "../../../enum/enum";
import { mapActions, mapGetters } from "vuex";
export default {
  props: {
    apartmentId: {
      type: Number,
      default: () => {
        return 0;
      }
    }
  },
  data: () => ({
    productData: {
      id: 0,
      productCode: null,
      productName: null,
      productGroup: null,
      productUnit: null,
      productPrice: null,
      productDescription: null
    },
    productGroupList: [],
    productUnitList: []
  }),
  watch: {
    GET_PRODUCT_GROUP_LIST_NO_PAGE_DATA: function() {
      let data = this.GET_PRODUCT_GROUP_LIST_NO_PAGE_DATA;
      this.productGroupList = [];
      data.forEach(value => {
        let item = {
          id: value.id,
          productGroupName: value.name,
          description: value.description
        };
        this.productGroupList.push(item);
      });
    },
    GET_PRODUCT_UNIT_LIST_NO_PAGE_DATA: function() {
      let data = this.GET_PRODUCT_UNIT_LIST_NO_PAGE_DATA;
      this.productUnitList = [];
      data.forEach(value => {
        let item = {
          id: value.id,
          productUnit: value.name,
          description: value.description
        };
        this.productUnitList.push(item);
      });
    }
  },
  computed: {
    ...mapGetters([
      "GET_PRODUCT_GROUP_LIST_NO_PAGE_DATA",
      "GET_PRODUCT_UNIT_LIST_NO_PAGE_DATA"
    ])
  },
  methods: {
    onShowAddNew: function(apartmentImgType) {
      $(this.$refs[`modal-product-detail`]).modal("show");
      this.productData = {
        id: 0,
        productCode: null,
        productName: null,
        productGroup: null,
        productUnit: null,
        productPrice: null,
        productDescription: null
      };
    },
    onShowDetail: function(data) {
      $(this.$refs[`modal-product-detail`]).modal("show");
      this.productData = {
        id: data.id,
        productCode: data.productCode,
        productName: data.productName,
        productGroup: data.productGroup,
        productUnit: data.productUnit,
        productPrice: data.productPrice,
        productDescription: data.productDescription
      };
    },
    onCloseModal: function() {
      $(this.$refs[`modal-product-detail`]).modal("hide");
    },
    validateData: function() {
      let validateResult = "OK";
      if (utils.isEmptyString(this.productData.productCode)) {
        validateResult = this.$t("product.productList.productCode");
      } else if (utils.isEmptyString(this.productData.productName)) {
        validateResult = this.$t("product.productList.productName");
      } else if (utils.isEmptyString(this.productData.productPrice)) {
        validateResult = this.$t("product.productList.productPrice");
      }
      return validateResult;
    },
    onSave: async function() {
      let result = this.validateData();
      if (result === "OK") {
        let data = {
          id: this.productData.id,
          product_group: this.productData.productGroup,
          product_unit: this.productData.productUnit,
          name: this.productData.productName,
          code: this.productData.productCode,
          price: this.productData.productPrice,
          description: this.productData.productDescription
        };
        if (this.productData.id === 0) {
          this.CREATE_PRODUCT(data)
            .then(
              function(res) {
                this.onCloseModal();
                this.$emit("callbackGetProduct");
              }.bind(this)
            )
            .catch(
              function(error) {
                this.ON_SHOW_TOAST({
                  message: error.response.data.message,
                  styleType: "danger"
                });
              }.bind(this)
            );
        } else {
          this.UPDATE_PRODUCT(data)
            .then(
              function(res) {
                this.onCloseModal();
                this.$emit("callbackGetProduct");
              }.bind(this)
            )
            .catch(
              function(error) {
                this.ON_SHOW_TOAST({
                  message: error.response.data.message,
                  styleType: "danger"
                });
              }.bind(this)
            );
        }
      } else {
        this.showError(result);
      }
    },
    showError: function(mess) {
      this.ON_SHOW_TOAST({
        message: mess,
        styleType: "danger"
      });
    },
    ...mapActions([
      "SUCCESS_TOAST",
      "ERROR_TOAST",
      "ON_SHOW_TOAST",
      "CREATE_PRODUCT",
      "UPDATE_PRODUCT"
    ])
  },
  mounted() {}
};
</script>
<style scoped>
label.required:not(:empty):after,
.field-header.required:after {
  content: " *";
  color: red;
  position: absolute;
  margin-left: 8px;
  top: 0px;
}
.asset-img-class {
  margin: auto;
  width: 100%;
  max-width: 200px;
  max-height: 250px;
  object-fit: contain;
}
.label-text-center {
  padding-bottom: 10px;
}
.remove-asset-img {
  color: #ef5350;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/Product/ProductDetail.vue